import { createNewCohort } from 'constants/helper';

import {
  levelUpAnalyticsCohortCreationActions,
  levelUpAnalyticsConstantsActions,
  levelUpAnalyticsFilterActions,
  levelUpAnalyticsOtherActions,
} from './actions';

export const levelUpAnalyticsFilterActionsReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case levelUpAnalyticsFilterActions.SELECT_COHORT:
      return {
        ...state,
        currentState: {
          ...state.currentState,
          selectedCohort: payload.cohort,
          noData: false,
          errorData: false,
        },
      };
    case levelUpAnalyticsFilterActions.SELECT_GROUPBY:
      return {
        ...state,
        currentState: {
          ...state.currentState,
          selectedGroupByKey: payload.groupByKey,
          noData: false,
          errorData: false,
        },
        // selectedView: {
        //   viewId: payload.groupByKey.keyName,
        //   expandedRowDetails: {
        //     headerComponent: null,
        //     infoObj: null
        //   }
        // }
      };
    case levelUpAnalyticsFilterActions.SELECT_SPLIT_BY_KEY:
      return {
        ...state,
        currentState: {
          ...state.currentState,
          selectedSplitByKey: payload.splitBy,
          noData: false,
          errorData: false,
        },
      };

    case levelUpAnalyticsFilterActions.SELECT_DATERANGE:
      return {
        ...state,
        currentState: {
          ...state.currentState,
          selectedDateRange: payload.dateRange,
          noData: false,
          errorData: false,
        },
      };
    case levelUpAnalyticsFilterActions.SELECT_TIMEBOUND_PERIODS:
      return {
        ...state,
        currentState: {
          ...state.currentState,
          selectedTimeBoundPeriods: payload?.timeBounds ?? [],
          noData: false,
          errorData: false,
        },
      };

    case levelUpAnalyticsFilterActions.SET_OPERATION_IN_PROGRESS:
      return {
        ...state,
        currentState: {
          ...state.currentState,
          inProgress: payload.inProgress,
        },
      };

    default:
      return state;
  }
};

export const levelUpAnalyticsCohortCreationActionsReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case levelUpAnalyticsCohortCreationActions.ADD_COHORT: {
      const newCohortList = createNewCohort(state.allCohorts, payload);
      return {
        ...state,
        allCohorts: newCohortList,
        currentState: {
          ...state.currentState,
          selectedCohort: payload.cohort,
          noData: false,
          errorData: false,
        },
      };
    }
    default:
      return state;
  }
};

export const levelUpAnalyticsConstantsReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case levelUpAnalyticsConstantsActions.SET_LEVEL_UP_PROGRESS_STATUSES: {
      return {
        ...state,
        levelUpProgressStatuses: payload,
      };
    }

    case levelUpAnalyticsConstantsActions.SET_LEVEL_UP_RISK_ESTIMATION_LIST: {
      return {
        ...state,
        riskEstimationList: payload,
      };
    }
    default:
      return state;
  }
};

export const levelUpAnalyticsCombinedReducer = (state, action) => {
  const { type, payload } = action;

  if (levelUpAnalyticsFilterActions[type]) {
    return levelUpAnalyticsFilterActionsReducer(state, action);
  }
  if (levelUpAnalyticsCohortCreationActions[type]) {
    return levelUpAnalyticsCohortCreationActionsReducer(state, action);
  }
  if (levelUpAnalyticsConstantsActions[type]) {
    return levelUpAnalyticsConstantsReducer(state, action);
  }
  switch (type) {
    case levelUpAnalyticsOtherActions.INITIALIZE_STATE: {
      let sortedCohorts = [...payload.cohorts];
      sortedCohorts = sortedCohorts.sort((objA, objB) => {
        if (String(objA.name).toLowerCase() === 'last used') return -1;

        if (String(objB.name).toLowerCase() === 'last used') return 1;

        return 0;
      });

      const reactSelectGroupByForMyTeam = payload.groupByKeys
        ?.map((option) => {
          const { displayName, enabled, keyName } = option;
          return {
            label: displayName,
            isDisabled: !enabled,
            value: keyName,
            apiValue: {
              ...option,
            },
          };
        })
        .filter(({ value }) => value !== 'orgTree');

      const reactSelectGroupByForMyOrgAndAllEmps = payload.groupByKeys
        ?.map((option) => {
          const { displayName, enabled, keyName } = option;
          return {
            label: displayName,
            isDisabled: !enabled,
            value: keyName,
            apiValue: {
              ...option,
            },
          };
        })
        .filter(({ value }) => value !== 'employeeId');

      const reactSelectGroupBy = payload.groupByKeys?.map((option) => {
        const { displayName, enabled, keyName } = option;
        return {
          label: displayName,
          isDisabled: !enabled,
          value: keyName,
          apiValue: {
            ...option,
          },
        };
      });

      const reactSelectSplitBy = payload.splitByKeys?.map((option) => {
        const { displayName, enabled, keyName } = option;
        return {
          label: displayName,
          isDisabled: !enabled,
          value: keyName,
          apiValue: {
            ...option,
          },
        };
      });

      return {
        ...state,
        allCohorts: sortedCohorts,
        allGroupByKeys: reactSelectGroupBy,
        allSplitByKeys: reactSelectSplitBy,
        reactSelectGroupByForMyTeam,
        reactSelectGroupByForMyOrgAndAllEmps,
        currentState: {
          ...state.currentState,
          selectedCohort: payload.selectedCohort ?? payload.cohorts[0],
          selectedGroupByKey: payload.selectedGroupByKey ?? payload.groupByKeys[0],
          selectedSplitByKey: payload.selectedSplitByKey ?? payload.splitByKeys[0],

          noData: false,
          errorData: false,
        },
        // selectedView: {
        //   viewId: payload.selectedGroupByKey?.keyName ?? payload.groupByKeys[0]?.keyName,
        //   expandedRowDetails: {
        //     headerComponent: null,
        //     infoObj: null
        //   }
        // }
      };
    }
    case levelUpAnalyticsOtherActions.CHANGE_VIEW: {
      return {
        ...state,
        selectedView: {
          viewId: payload.viewId,
          expandedRowDetails: {
            headerComponent: null,
            infoObj: null,
          },
        },
        currentState: {
          ...state.currentState,
          noData: false,
          errorData: false,
        },
      };
    }
    case levelUpAnalyticsOtherActions.SET_EXPANSION_VIEW_DETAILS: {
      return {
        ...state,
        selectedView: {
          ...state.selectedView,
          expandedRowDetails: {
            headerComponent: payload.headerComponent,
            infoObj: payload.infoObj,
          },
        },
        currentState: {
          ...state.currentState,
          noData: false,
          errorData: false,
        },
      };
    }
    case levelUpAnalyticsOtherActions.CLEAR_EXPANSION_VIEW_DETAILS: {
      return {
        ...state,
        selectedView: {
          ...state.selectedView,
          expandedRowDetails: {
            headerComponent: null,
            infoObj: null,
          },
        },
        currentState: {
          ...state.currentState,
          noData: false,
          errorData: false,
        },
      };
    }
    case levelUpAnalyticsOtherActions.SET_NO_DATA: {
      return {
        ...state,
        currentState: {
          ...state.currentState,
          noData: payload.noData,
        },
      };
    }
    case levelUpAnalyticsOtherActions.SET_ERROR_DATA: {
      return {
        ...state,
        currentState: {
          ...state.currentState,
          errorData: payload.errorData,
        },
      };
    }

    default: {
      return state;
    }
  }
};
